import { Worker, Viewer } from '@react-pdf-viewer/core'
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/thumbnail/lib/styles/index.css'

// NOTE: components
import { pageThumbnailPlugin } from './pageThumbnailPlugin'

interface PdfThumbnailProps {
    fileUrl: any
}

const PdfThumbnail = ({ fileUrl }: PdfThumbnailProps) => {
    // add thumbnail to pdf viewer
    const thumbnailPluginInstance = thumbnailPlugin();
    const { Cover } = thumbnailPluginInstance;
    const pageThumbnailPluginInstance = pageThumbnailPlugin({
        PageThumbnail: <Cover getPageIndex={() => 0} />,
    })

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer fileUrl={fileUrl} plugins={[pageThumbnailPluginInstance, thumbnailPluginInstance]} />
        </Worker>
    )
}

export default PdfThumbnail